import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./store/store"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'
import { Provider } from "react-redux"
import App from "./App"
import { store } from './store';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://2226318eafd74bb88de569cfce55acb6@o1183823.ingest.sentry.io/4503959223664640",
//       integrations: [new BrowserTracing()],


//   tracesSampleRate: 1.0,
// });


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </I18nextProvider>
    </PersistGate>
  </Provider >
);
reportWebVitals();
